<template>
  <vue3-progress />

  <div class="cols">
    <div class="logo">
      <img alt="logo" src="@/assets/img/SATRA_logo.png">
    </div>
    <div class="title">
      INŽENÝRING | SPRÁVA PODÁNÍ
    </div>
  </div>

  <div v-if="isLogged" class="cols content">
    <MenuComp
      class="menu"
      :menuItem="menuItem"
      @loggoutUser="loggoutUser"
      @setMenuItem="setMenuItem"
      :isEditor="isEditor"
      :isManager="isManager"
      :isInvestor="isInvestor"
      :isAdmin="isAdmin"
      :isProjektant="isProjektant"
    />

    <MainComp
      class="main"
      :menuItem="menuItem"
      @setMenuItem="setMenuItem2"
      :isEditor="isEditor"
      :isManager="isManager"
      :isInvestor="isInvestor"
      :idUser="loggedUser.id"
      :idZakazka="idZakazka"
      :isAdmin="isAdmin"
      :isProjektant="isProjektant"
    />
  </div>  

  <Login v-else class="login" @setLoggedUser="setLoggedUser" />
</template>

<script>
  import Login from './components/Login.vue'
  import MenuComp from './components/Menu.vue'
  import MainComp from './components/Main.vue'

  export default {
    name: 'App',
    data() {
      return {
        isLogged: false,
        isEditor: false,
        isManager: false,
        isInvestor: false,
        isAdmin: false,
        isProjektant: false,
        loggedUser: {},
        menuItem: -1,
        idZakazka: -1
      }
    },
    components: {
      Login,
      MenuComp,
      MainComp
    },
    methods: {
      setLoggedUser(value) {
        if (value !== null && Object.keys(value).length !== 0) {
          this.menuItem = -1
          this.idZakazka = -1
          this.isLogged = true
          this.loggedUser = value
          this.isEditor = this.loggedUser.idRole === 2 ? true : false
          this.isManager = this.loggedUser.idRole === 3 ? true : false
          this.isInvestor = this.loggedUser.idRole === 4 ? true : false
          this.isAdmin = this.loggedUser.idRole === 5 ? true : false
          this.isProjektant = this.loggedUser.idRole === 6 ? true : false
        }
      },
      loggoutUser() {
        this.isLogged = false
        this.loggedUser = {}
      },
      setMenuItem(value) {
        this.menuItem = value
        this.idZakazka = -1
      },
      setMenuItem2(value, idzakazka) {
        this.menuItem = value
        this.idZakazka = idzakazka
      }
    }
  }
</script>